import { NormalText } from 'components/styled/text.styled';
import { InputField } from 'components/Inputs/Input';
import { TextArea } from 'components/Inputs/TextArea';
import BackgroundImage from 'components/layouts/BackgroundImage';
import SelectOption from 'components/Inputs/SelectOption';
import { ImageSource } from 'modules/assetpath';
import { Box, Stack } from 'components/styled/layout.styled';
import GradientButton from 'components/Buttons/GradientButton';
import React, { useState } from 'react';
import AppLayout from 'components/layouts/AppLayout';

const JoinSchool = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <AppLayout
    noMargin={true}
    opacityBg='0.04' 
    appBar={{
      bg: {},
      navleft: {
        bg: 'ic-arrow-back-light',
        width: '24px',
        height: '24px',
      },
      navright: {
        variant: ''
      },
      isDisable: false,
      title: `Tertarik Bergabung`
    }}
      backgroundImage={ImageSource('app.background')}
      showModal={showModal}
      modalContent={
        <Box padding="16px" width="100%">
          <Stack direction="column" margin="16px">
            <NormalText
              textAlign="center"
              color="#FFFFFF"
              fontSize="16px"
              fontWeight="bold"
              margin="8px 0px"
            >
              Terima Kasih!
            </NormalText>
            <NormalText
              textAlign="center"
              color="#969393"
              fontSize="14px"
              fontWeight="normal"
              margin="8px 0px"
            >
              Kami telah menerima permintaanmu.
            </NormalText>
            <br />
            <Box padding="8px" width="100%">
              <Stack direction="column" align="center">
                <GradientButton
                  onClick={() => setShowModal(false)}
                  styled={{
                    backgroundSize: '100%',
                    width: '180px',
                  }}
                  variant="primary"
                >
                  OK
                </GradientButton>
              </Stack>
            </Box>
          </Stack>
        </Box>
      }
    >
      <BackgroundImage
        src={ImageSource('card.background')}
        backgroundColor="#131318"
        mask="linear-gradient(transparent, #00000090, #00000023, transparent)"
        //   styled={styled}
      >
        <NormalText
          style={{ marginLeft: '10px', marginRight: 'auto', marginTop: '35px' }}
          fontSize="18px"
          fontWeight="bold"
          lineHeight="140%"
          color="white"
          textAlign="left"
        >
          Kamu Kepala Sekolah, Guru atau Staf?
        </NormalText>
        <NormalText
          style={{ marginBottom: '40px' }}
          fontSize="12px"
          fontWeight="normal"
          lineHeight="140%"
          color="#DDD8D8"
          textAlign="left"
          margin="10px"
        >
          Jika kamu ingin mengembangkan esport di sekolah mu, isi form di bawah ini untuk bergabung
          dengan MABAR.
        </NormalText>
      </BackgroundImage>
      <div style={{margin:'12px'}}>
        <InputField
          label="Nama"
          onChange={() => {}}
          inputMode="text"
          // onClick={function noRefCheck() {}}
          placeholder="John Doe"
        />
        <InputField
          label="Email"
          onChange={() => {}}
          // onClick={function noRefCheck() {}}
          placeholder="johndoe@gmail.com"
          inputMode="email"
        />
        <InputField
          label="Nomor Ponsel"
          onChange={() => {}}
          // onClick={function noRefCheck() {}}
          placeholder="0812xxxxxxx"
          inputMode="tel"
        />
        <InputField
          label="Tipe Laporan"
          onChange={() => {}}
          // onClick={function noRefCheck() {}}
          placeholder="Permintaan Bergabung sebagai Perwakilan Sekolah"
          inputMode="text"
          style={{background:'rgba(46, 50, 56, 0.6)'}}
          disabled={true}
        />
        <SelectOption
          // onChange={() => {}}
          // onClick={function noRefCheck() {}}
          // onItemChange={function noRefCheck() {}}
          option={[
            {
              label: 'Jawa Barat',
              value: 'westjava',
            },
            {
              label: 'Jawa Timur',
              value: 'eastjava',
            },
            {
              label: 'DKI Jakarta',
              value: 'jakarta',
            },
          ]}
          placeholder="Pilih Provinsi"
          label="Provinsi"
        />
        <br />
        <SelectOption
          // onChange={() => {}}
          // onClick={function noRefCheck() {}}
          // onItemChange={function noRefCheck() {}}
          option={[
            {
              label: 'Bandung',
              value: 'bandung',
            },
            {
              label: 'Surabaya',
              value: 'surabaya',
            },
            {
              label: 'Jakarta',
              value: 'jakarta',
            },
          ]}
          placeholder="Pilih Kota"
          label="Kota"
        />
        <br />
        <SelectOption
          // onChange={() => {}}
          // onClick={function noRefCheck() {}}
          // onItemChange={function noRefCheck() {}}
          option={[
            {
              label: 'SMA 2 Bandung',
              value: 'sma2bdg',
            },
            {
              label: 'SMA 1 Bandung',
              value: 'sma1bdg',
            },
            {
              label: 'SMA 3 Bandung',
              value: 'sma3bdg',
            },
          ]}
          placeholder="Pilih Sekolah"
          label="Sekolah"
        />
        <br />
        <SelectOption
          // onChange={() => {}}
          // onClick={function noRefCheck() {}}
          // onItemChange={function noRefCheck() {}}
          option={[
            {
              label: 'Kepala Sekolah',
              value: 'kepsek',
            },
            {
              label: 'Guru',
              value: 'guru',
            },
            {
              label: 'Staff',
              value: 'staff',
            },
          ]}
          placeholder="Pilih Role"
          label="Role"
        />
        <br />
        <TextArea
          label="Pesan"
          onChange={() => {}}
          // onClick={function noRefCheck() {}}
          placeholder="Saya tertarik membuat eskul esport"
          inputMode="text"
          type="textarea"
        />
        <br />
        <Box padding="8px" width="100%">
          <Stack direction="column" align="center">
            <GradientButton
              onClick={() => setShowModal(true)}
              styled={{
                backgroundSize: '100%',
                width: '100px',
              }}
              variant="primary"
            >
              Kirim
            </GradientButton>
          </Stack>
        </Box>
      </div>
    </AppLayout>
  );
};

export default JoinSchool;
